import React, { Component } from "react";
import Modal from "react-modal";
// import { Redirect } from "react-router-dom";

import axios from "axios";
import Select from "react-select";
import LoadingPage from "../../components/Loading/Loading";
import config from "../../config";
import utilityFunctions from "../../store/utilityFunctions";
import errorFunctions from "../../store/errorFunctions";

import "./StaffAdd.css";
import "../common.css";
Modal.setAppElement("body");

const roleOptions = [
  { label: "Commercial Admin", value: "Commercial Admin" },
  { label: "Commercial Staff", value: "Commercial Staff" },
];
export default class StaffAdd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      redirect: false,
      statusTicket: "",
      modalStatusConfirm: false,
      brands: [],
      roles: [],
      currentRole: "Commercial Staff",
      name: "",
      email: "",
      password1: "",
      password2: "",
      errorPassword: false,
      errorBrand: false,
      typePassword: true,
      locationOptions: [],
    };
  }

  componentDidMount() {
    this.retriveAllBrand();
    this.retriveAllRoles();
    this.retrieveStoreLocation();
  }
  retrieveStoreLocation = () => {
    this.setState({
      isLoading: true,
      // deviceId: brandDevice[0]?.id,
    });
    this.props
      .protectedFetch(
        config.backendServer + "store_locations/",
        "GET",
        { country: config.country },
        errorFunctions.checkResponseThenJson
      )
      .then((res) => {
        const options = res.map((r) => {
          return { label: r.seller_name + " - " + r.name, value: r.id };
        });

        this.setState({
          sellers: res,
          filteredSellers: res,
          isLoading: false,
          locationOptions: [...[{ label: "---", value: "" }], ...options],
          selectedSeller: options.find((s) => s.value === res[0].id),
          // stores: res[0].store_locations,
          // deviceId: brandDevice[0]?.id,
        });
        this.retrieveStore(res[0].id);
      })
      .catch((err) => console.log(err));
  };
  postNewStaffFunction(payload) {
    const userInfo =
      localStorage?.getItem("userInfo") ||
      utilityFunctions?.getCookie("userInfo");
    const token = (userInfo && JSON?.parse(userInfo)?.access_token) || "";
    let options = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    return new Promise((resolve) => {
      axios
        .post(`${config.backendServer}employee/`, payload, options)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          resolve(err);
        });
      this.setState({ loading: false });
    });
  }

  retriveAllBrand = () => {
    this.setState({ loading: true });
    this.props
      .protectedFetch(
        config.backendServer + "brands/",
        "GET",
        null,
        errorFunctions.checkResponseThenJson
      )
      .then((res) => {
        this.setState({ loading: false, brands: res });
      })
      .catch(() => {
        console.log("fail brand");
        this.setState({ loading: false });
      });
  };

  retriveAllRoles = () => {
    this.setState({ loading: true });
    this.props
      .protectedFetch(
        config.backendServer + "roles/",
        "GET",
        null,
        errorFunctions.checkResponseThenJson
      )
      .then((res) => {
        this.setState({ loading: false, roles: res });
      })
      .catch(() => {
        console.log("fail brand");
        this.setState({ loading: false });
      });
  };

  handleSubmit = async (event) => {
    this.setState({ loading: true });
    event.preventDefault();
    const selectedBrandIds = Array.from(
      document.querySelectorAll("input[type='checkbox']:checked")
    ).map((checkbox) => checkbox.value);

    let payload = {
      brands: selectedBrandIds,
      name: this.state.name ? this.state.name : this.state.details.name,
      email: this.state.email ? this.state.email : this.state.details.email,
      user_role: this.state.currentRole,
      password1: this.state.password1,
      password2: this.state.password2,
    };

    if (
      payload.password1 !== payload.password2 &&
      payload.brands.length === 0
    ) {
      this.setState({ loading: false, errorPassword: true, errorBrand: true });
    } else if (payload.password1 !== payload.password2) {
      this.setState({ loading: false, errorPassword: true, errorBrand: false });
    } else if (payload.brands.length === 0) {
      this.setState({ loading: false, errorBrand: true, errorPassword: false });
    } else {
      const result = await this.postNewStaffFunction(payload);
      if (result.status === 200 || result.status === 201) {
        this.props.addExistingUser(result.data?.id, this.state.storeLocationId);
        this.props.closeModal();
        this.props.retrieveStaffs();
      } else {
        alert(result?.response?.data.non_field_errors?.[0]);
        this.setState({ loading: false });
      }
    }
  };
  handleRole = (e) => {
    this.setState({ currentRole: e.target.value });
  };
  handleChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  render() {
    if (this.state.loading) {
      return <LoadingPage />;
    }

    return (
      <div className="card">
        <h4 className={"card-header"}>Add Staff</h4>
        <form onSubmit={this.handleSubmit}>
          <div className="card-body">
            <div className={"single-warranty-details-item"}>
              <label className={"single-warranty-details-label required"}>
                Full name<span>:</span>
              </label>
              <input
                type="text"
                id="name"
                required={true}
                className="form-control"
                onChange={this.handleChange}
              />
            </div>

            <div className={"single-warranty-details-item"}>
              <label className={"single-warranty-details-label required"}>
                Email <span>:</span>
              </label>
              <input
                type="email"
                id="email"
                required={true}
                className="form-control"
                onChange={this.handleChange}
              />
            </div>

            <div className={"single-warranty-details-item"}>
              <label className={"single-warranty-details-label required"}>
                Brands<span>:</span>
              </label>
              <span>
                {this.state.brands.map((brand) => (
                  <div className="col-6" key={brand.id}>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`brand-${brand.id}`}
                        value={brand.id}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`brand-${brand.id}`}
                      >
                        {brand.name}
                      </label>
                    </div>
                  </div>
                ))}
              </span>
              {this.state.errorBrand ? (
                <span className="error-text">Pick at least one brand.</span>
              ) : null}
            </div>
            <div className={"single-warranty-details-item"}>
              <label className={"single-warranty-details-label required"}>
                Password{" "}
                <i
                  className={
                    this.state.typePassword
                      ? "password-show fa fa-eye"
                      : "password-show fa fa-eye-slash"
                  }
                  aria-hidden="true"
                  onClick={() =>
                    this.setState({ typePassword: !this.state.typePassword })
                  }
                ></i>
                <span>:</span>
              </label>
              <input
                type={this.state.typePassword ? "password" : "text"}
                id="password1"
                required={true}
                className="form-control"
                onChange={this.handleChange}
              />
              {this.state.errorPassword ? (
                <span className="error-text">Password did not match</span>
              ) : null}
            </div>

            <div className={"single-warranty-details-item"}>
              <label className={"single-warranty-details-label required"}>
                Confirm Password <span>:</span>
              </label>
              <input
                type={this.state.typePassword ? "password" : "text"}
                id="password2"
                required={true}
                className="form-control"
                onChange={this.handleChange}
              />
              {this.state.errorPassword ? (
                <span className="error-text">Password did not match</span>
              ) : null}
            </div>
            <div className={"single-warranty-details-item"}>
              <label className={"single-warranty-details-label"}>Role:</label>
              <Select
                required
                options={roleOptions}
                value={roleOptions.find(
                  (x) => x.value === this.state.currentRole
                )}
                placeholder="Select Role"
                onChange={(e) => {
                  this.setState({
                    currentRole: e.value,
                  });
                }}
                // onInputChange={(val) => this.searchLocationState(val)}
              />
            </div>
            <div className={"single-warranty-details-item"}>
              <label className={"single-warranty-details-label"}>
                Store Location<span>:</span>
              </label>
              <Select
                required
                options={this.state.locationOptions}
                placeholder="Select Location"
                onChange={(e) => {
                  this.setState({ storeLocationId: e.value });
                }}
                // onInputChange={(val) => this.searchLocationState(val)}
              />
            </div>
          </div>

          <div className="card-footer">
            <div className="d-flex flex-row mb-3 gap-2">
              <div>
                <button className={"btn btn-outline-primary"}>Create</button>
              </div>
              <div>
                <button
                  className={"btn btn-outline-secondary"}
                  onClick={() => this.props.closeModal()}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}
